import { window } from "global";
import { useEffect, useMemo } from "react";
import { usePageTitleAndDesc } from "@ugg/shared/utils/seo-helpers";
import { Link } from "react-router-dom";
import { SvgArrowPointRight } from "@ugitgud/legos/ui/icon/SVG/ArrowPointRight";
import { getCareersPostUrl } from "@ugg/shared/routes/app-routes";
import { JOB_POSTINGS } from "./jobPostings";

const CareersHome = () => {
  const getPageTitleAndDesc = usePageTitleAndDesc();

  useEffect(() => {
    window && window.scrollTo(0, 0);
  }, []);

  const jobsByDepartment = useMemo(
    () =>
      JOB_POSTINGS.reduce<Record<string, typeof JOB_POSTINGS>>((acc, job) => {
        (acc[job.department] ??= []).push(job);
        return acc;
      }, {}),
    [],
  );

  return (
    <div className="text-content-container px-6">
      {getPageTitleAndDesc("careers")}
      <div className="text-content">
        <h1 className="mb-8">Careers at U.GG</h1>
        <p className="!text-lavender-50 mb-10">
          U.GG was built to take the guesswork out of gaming. We analyze hundreds of millions of matches to offer players useful
          tools and support across League of Legends, Valorant, World of Warcraft, Deadlock, and more. Your work and contributions
          will support and benefit over 10 million players that use our platform monthly. We're a small, fully remote team of
          competitive gamers who build tools we actually use ourselves. If you're interested in joining the team, please let us
          know!
        </p>
        {JOB_POSTINGS.length === 0 ? (
          <span className="text-gray-400 text-[16px]">No open positions at this time. Check back soon!</span>
        ) : (
          Object.entries(jobsByDepartment).map(([dept, jobs]) => (
            <div key={dept} className="mb-10">
              <h2 className="mb-4">{dept}</h2>
              <div className="flex flex-col gap-2">
                {jobs.map((job) => (
                  <Link
                    key={job.slug}
                    to={getCareersPostUrl(job.slug)}
                    className="flex items-center justify-between rounded-lg bg-purple-400 px-5 py-4 hover:bg-purple-100 !no-underline"
                  >
                    <div className="flex flex-col gap-1">
                      <span className="text-[14px] text-white font-semibold">{job.title}</span>
                      <span className="text-[12px] text-gray-400">
                        {job.location} &middot; {job.type}
                      </span>
                    </div>
                    <div className="text-white h-[24px] w-[24px]">
                      <SvgArrowPointRight />
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CareersHome;
